import xhr from 'helpers/XHR'

export const postEvent = async(event, params) => {
  try {
    await xhr.post('/analytics', {
      event,
      metadata: params
    })
  } catch (e) {
    console.log('Segment postEvent failed:', e.message)
  }
}
